import { render, staticRenderFns } from "./LayoutPicker.vue?vue&type=template&id=787b0cf7&scoped=true"
import script from "./LayoutPicker.vue?vue&type=script&lang=js"
export * from "./LayoutPicker.vue?vue&type=script&lang=js"
import style0 from "./LayoutPicker.vue?vue&type=style&index=0&id=787b0cf7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787b0cf7",
  null
  
)

export default component.exports